import * as Linking from "expo-linking";
/* -----------------Globals--------------- */
import {
	Stack,
	useFocusEffect,
	useLocalSearchParams,
	useRouter,
} from "expo-router";

import { pageViewTypes } from "@constants/tracking";
import { AppBar } from "@features/dashboard/layouts/AppBar";
/* -----------------Child components--------------- */
import RedeemCodeCopilotWrapper from "@features/redeem/components/RedeemCodeCopilotWrapper";
import { handleNavigateBack } from "@helpers/common";
import { replayManager } from "@helpers/lib/sentry";
import useAnalytics from "@hooks/useAnalytics";
import { useAppStore } from "@hooks/useAppStore";
import { isWeb } from "@memorang/helpers/platform";
import { buildUrlWithSearchParams } from "@memorang/helpers/url";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

const RedeemRoute = () => {
	const params = useLocalSearchParams() as Record<
		string,
		string | string[] | undefined
	>;
	const step = Array.isArray(params.step) ? params.step[0] : params.step;
	const baseUrl = useAppStore((state) => state.app.links.baseUrl);
	const router = useRouter();
	const { t } = useTranslation();

	useFocusEffect(
		useCallback(() => {
			if (isWeb) {
				replayManager().startReplay();
				return;
			}

			if (baseUrl) {
				Linking.openURL(buildUrlWithSearchParams(baseUrl, "/redeem", params));
				router.push("/home");
			}
		}, [baseUrl, params, router]),
	);

	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.redeem,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	const title =
		step === "success"
			? t("redeemCode.titleGranted")
			: t("redeemCode.titleRedeem");

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: true,
					header: () => {
						return (
							<AppBar
								title={title}
								onPressBack={() => {
									handleNavigateBack("/(protected)/(tabs)/home");
								}}
								hideCommandBar
							/>
						);
					},
				}}
			/>
			<RedeemCodeCopilotWrapper />
		</>
	);
};

export default RedeemRoute;
